export enum ImageType {
  BACKGROUND = "background",
  MAIN = "main",
  HERO = "hero",
  HERO_LANDSCAPE = "hero_horizontal",
  THUMBNAIL = "thumbnail",
  THUMBNAIL_FEATURED = "thumbnail_featured",
  HEADER_LANDSCAPE = "header_landscape",
  HEADER_PORTRAIT = "header_portrait",
}

export interface Image {
  id: string;
  uuid: string;
  type: ImageType;
  url: string;
  urlMini?: string;
  theme?: string;
  brandedOption?: "brandedLight" | "brandedDark";
}

export const getImageByThemeName = (
  themeName: string,
  images: Image[],
): Image | undefined => {
  for (const image of images) {
    if (image.theme === themeName) return image;
  }
  return undefined;
};
